import { WrappedFieldProps } from 'redux-form';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Link } from 'react-router-dom';
import * as React from 'react';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

type InputOrAreaProps = React.HTMLProps<HTMLInputElement | HTMLTextAreaElement>;

export interface Props extends Omit<InputOrAreaProps, 'ref'> {
  toggleShowPassword?: () => void;
  isPassword?: boolean;
  type?: string;
  isPasswordShown?: boolean;
  id?: string;
  label?: string;
  forgotPasswordMessage?: string;
  forgotPasswordLink?: string;
  rightIcon?: JSX.Element;
  leftIcon?: JSX.Element;
}

const Input: React.FC<Props & WrappedFieldProps> = ({
  id,
  label,
  isPassword,
  type,
  input,
  forgotPasswordLink,
  rightIcon,
  leftIcon,
  forgotPasswordMessage,
  meta,
  ...props
}) => {
  const [isPasswordShown, toggleShowPassword] = React.useState(false);
  const handletoggleShowPassword = (): void => {
    toggleShowPassword(!isPasswordShown);
  };
  const passwordFieldType = isPasswordShown ? 'text' : 'password';

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ): void => {
    event.preventDefault();
  };

  return (
    <div
      className={`form-group ${meta?.submitFailed &&
        (meta?.error || meta?.warning) &&
        'u-has-error'}`}
    >
      <label className="form-label" htmlFor={id}>
        <span className="d-flex justify-content-between align-items-center">
          {label}

          {isPassword && forgotPasswordMessage && (
            <Link
              className="link-muted  font-weight-normal"
              to={forgotPasswordLink || ''}
            >
              {forgotPasswordMessage}
            </Link>
          )}
        </span>
      </label>
      <div className="input-group">
        {leftIcon && (
          <div className="input-group-append">
            <span className="input-group-text" id="basic-addon2">
              {leftIcon}
            </span>
          </div>
        )}
        {type === 'textarea' ? (
          <textarea
            {...(props as React.HTMLProps<HTMLTextAreaElement>)}
            {...input}
            className="form-control"
          />
        ) : (
          <input
            type={!isPassword ? type : passwordFieldType}
            {...input}
            {...(props as React.HTMLProps<HTMLInputElement>)}
            className="form-control"
          />
        )}
        {rightIcon && (
          <div className="input-group-append">
            <span className="input-group-text" id="basic-addon2">
              {rightIcon}
            </span>
          </div>
        )}
        {isPassword && (
          <div className="input-group-append">
            <span className="input-group-text p-0">
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handletoggleShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {!isPasswordShown ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            </span>
          </div>
        )}
      </div>

      {meta?.submitFailed &&
        ((meta?.error && (
          <div className="invalid-feedback" style={{ display: 'block' }}>
            {meta?.error}
          </div>
        )) ||
          (meta?.warning && (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {meta?.warning}
            </div>
          )))}
    </div>
  );
};

export default Input;
